import React, { useEffect, useState } from 'react';
import '../../../css/custom-accordion.css';
import { useParams, useLocation } from 'react-router';
import LenderUgroService from '../../../services/lender';
import MasterDataService from '../../../services/master-data';
import { Context } from '../../../config/store';
import Accordion from '../../../components/Portfolio/Accordion';
import Table from '../../../components/Common/Table';
import message from '../../../constant/message';
import { toast } from 'react-toastify';
import { objectsForEach } from '../../../common/objectToArray';
import { getFormattedDate } from '../../../common/date';
import DocumentDownload from './DocumentDownload';
import DocumentUploadField from './DocumentUploadField';
import Coapplicant from './Coapplicant';
import Modal from '../../../components/Modal';
import './Document.css'
import DateFormatter from '../../../components/Common/DateFormatter';

const Documents = ({
	cl_lead_lender_status,
	selectedLender,
	selectedLenderName,
	getLeadDetail,
	leadInfo,
	isPostDisbursalCase = false
}) => {
	const location = useLocation();
	const [modalState, setModalState] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false)
	const [rowdata, setRowdata] = useState(null)
	const { state } = React.useContext(Context);
	const leadId = useParams().id;
	const [documentList, setDocumentList] = React.useState({});
	const [uploadDocInfo, setUploadDocInfo] = React.useState({});
	const [fetchingDocuments, setFetchingDocuments] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	// const [file, setFile] = React.useState([]);
	const [documentData, setDocomentData] = React.useState();
	const [errors, setErrors] = React.useState({});
	const [getDocumentError, setGetDocumentError] = React.useState(false);
	const [getDocumentErrorMessage, setGetDocumentErrorMessage] =
		React.useState('');
	const [allSelected, setAllSelected] = React.useState(false);
	const [applicantData, setApplicantData] = useState([])
	const [co_applicants, setco_applicants] = useState('')
	const [uploadedFiles, setUploadedFiles] = useState([])
	// const [fileLimit, setFileLimit] = useState(false);
	const [MAX_COUNT, setMAX_COUNT] = useState();
	const [isDocumentSubmitting, setIsDocumentSubmmiting] = useState(-1)
	const [docloader, setDocloader] = useState(false)
	const [docloderHandler, setDocloderHandler] = useState(true)
	const [docKeys, setDocKeys] = useState([])
	const [selectedDocKey, setSelectedDocKey] = useState([])
	const [selectedDocValue, setSelectedDocValue] = useState([])
	const [activeDoc, setActiveDoc] = useState("")
	const [docCount, setDocCount] = useState(0)
	const [docID, setDocID] = useState('')

	const toggleModal = () => {
		setErrors({});
		setLoading(false)
		setModalState(!modalState);
	};
	const toggleModalConfirm = () => {
		setLoading(false)
		setConfirmModal(!confirmModal);
	}
	let inputRef = React.useRef(null);
	const documentFileTableHeaders = [
		{
			title: 'File Name',
			field: 'file_name',
		},
		{
			title: 'Applicant Type',
			field: 'cl_coapplicant_id',
			component: Coapplicant,
		},
		{
			title: 'Uploaded On',
			field: 'created_at',
			component: DateFormatter,
		},
		{
			title: 'Action',
			field: 'action',
			component: DocumentDownload,
		},
	];
	const defaultState = {
		document_types: {
			type: 'select',
			value: '',
			dataType: 'array',
		},
	};
	const bankFields = {
		bank_types: {
			type: 'select',
			value: '',
			label: 'Bank Name',
		},
		document_password: {
			type: 'text',
			value: ' ',
		},
	};
	const bankStatementFields = {
		account_holder_name: {
			type: 'text',
			value: ' ',
		},
		account_type: {
			type: 'select',
			value: ' ',
		},
		// ODCC: {
		// 	type: 'text',
		// 	value: ' ',
		// 	label: 'ODCC Limit',
		// },
		// ifsc: {
		// 	type: 'text',
		// 	value: ' ',
		// 	label: 'IFSC',
		// },

		account_number: {
			type: 'text',
			value: ' ',
		},
	};
	const reportFields = {
		report_type: {
			type: 'select',
			value: '',
		},
		applicant_type: {
			type: 'select',
			value: '',
		},
		pan_no: {
			type: 'text',
			value: ' ',
			label: 'PAN',
		},
		score: {
			type: 'text',
			value: '',
			label: 'Bureau Score',
		}	
	};
	const panCardInfo = {
		applicant_type: {
			type: 'select',
			value: '',
		}
	};
	const additionalFields = {
		RefNumber: {
			type: 'text',
			value: '',
		},
		IssueDate: {
			type: 'date',
			value: '',
		},
		DocIssuingAuthority: {
			type: 'select',
			value: '',
		},
		PlaceOfIssue: {
			type: 'select',
			value: '',
		},
		PreferredFlag: {
			type: 'select',
			value: '',
		},
	};
	const docInfo = {
		ReferenceNumber: {
			type: 'text',
			value: '',
		},
	}
	const annualTurnOver = {
		annual_turnover: {
			type: 'Number',
			value: '',
		},
	};
	const businessSector = {
		business_sector: {
			type: 'select',
			value: '',
		}
	};
	const businessSubSector = {
		business_sub_sector: {
			type: 'select',
			value: '',
		}
	};
	const industryType = {
		industry_type: {
			type: 'select',
			value: '',
		}
	};
	const subIndustryType = {
		sub_industry_type: {
			type: 'select',
			value: '',
		}
	};

	const prod_ids = [1,3,5,9,10,11,19,21,22,24,26,32,34,36,37,38,39,45,46,48,49,50,51,52,56,58,59,61,67,71,85,87,88,89,90,91,92,93,94,98,99,102,106,107,108,109,110,111,113,114,116,117,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,163,164,165,166,167,168,169];

	const getReportFields = (co_id, do_id)=> {
		let {pan_no, score, ...rest} = reportFields;
		if(do_id == null){
			setUploadDocInfo({
				['document_types']: {
					...uploadDocInfo['document_types'],
					value: '',
				},
			});
		}else{
			if(co_applicants && (do_id || docID) == 51){
				if(selectedLender == 3 && leadInfo.cl_lead.lead_type == 2 && leadInfo.cl_lead.loan_amount <= 2500000 && prod_ids.includes(leadInfo.cl_lead.prod_type) && co_applicants && !leadInfo?.coapplicants?.[co_applicants]){
					return {...rest, score};
				}else{
					return {...rest, pan_no};
				}
			}else{
				return {...rest, pan_no};
			}
		}
	}

	const viewableSelectedLender = (row) => {
		return (
			typeof row?.for_lenders === 'string'
				? JSON.parse(row.for_lenders)
				: row?.for_lenders || []
		).some((lender) => lender === selectedLender);
	};
	const getLeadDocument = async (isDefault) => {
		setDocloader(true)
		setGetDocumentError(false);
		setGetDocumentErrorMessage('');
		try {
			const response = await LenderUgroService.getPortfolioDocuments({
				type: state.userType,
				leadId: leadId,
				lenderId: allSelected ? 0 : selectedLender,
			});
			let docData = objectsForEach(response.data.data.lead_documents)
			let keys = []
			let values = []
			docData?.map(({ id, value }) => {
				if (value[0]?.document_file?.length > 0 || (leadInfo?.req_docs || [])?.includes(id)) {
					let docName = id;
					let docCount = value[0]?.document_file?.length;
					let leftData = {
						docName,
						docCount,
						value
					}
					keys.push(leftData)
					values.push(value)
				}
				if ((id === activeDoc) && !isDefault) {
					setSelectedDocValue(value)
				}
			})
			isDefault && !isPostDisbursalCase && setActiveDoc(keys[0]?.docName)
			isDefault && !isPostDisbursalCase && setSelectedDocValue(keys[0]?.value)
			isDefault && !isPostDisbursalCase && setDocCount(keys[0]?.value[0]?.document_file?.length)
			if (isPostDisbursalCase) {
				keys?.map(({ docName, docCount, value }) => {
					if (docName === "Statement of Account") {
						setDocKeys([{
							docName,
							docCount,
							value
						}])
						setActiveDoc(docName)
						setDocCount(docCount)
						setSelectedDocValue(value)
					}
				})
			} else {
				setDocKeys(keys)
			}
			setDocumentList(response.data.data.lead_documents);

			let data = documentData?.co_applicants
			if (data !== undefined) {
				let finaldata = []
				for (const [key, value] of Object?.entries(data)) {
					finaldata?.push({ id: key, value })
				}
				setApplicantData(finaldata);
			}
			getUploadDocumentData();
			setDocloader(false)
			setDocloderHandler(false)
		} catch (err) {
			let error = err?.response?.messages?.error;
			setGetDocumentError(true);
			setGetDocumentErrorMessage(
				error?.form?.[0] || error?.others?.[0] || message.ERROR_FORM
			);
			setDocloader(false)
			setDocloderHandler(false)
		}
	};

	const getUploadDocumentData = async () => {
		const response = await MasterDataService.getDocumentList(
			state.userType,
			'co-lender',
			leadId,
			selectedLender
		);

		setDocomentData(response.data.data);
		setMAX_COUNT(response.data.data.max_file_count)
	};

	const submitUploadDocument = async (e) => {
		e.preventDefault();
		if (!uploadedFiles) {
			return toast.error(message.SELECT_FILE);
		}
		setLoading(true);
		let formData = new FormData();
		Object.keys(uploadDocInfo).forEach((key) => {
			if (key === 'document_types') {
				if (documentData.document_types[uploadDocInfo[key].value]?.is_optional == 1) {
					formData.append(
						'is_optional', 1
					);
				}
				formData.append(
					'doc_type',
					documentData.document_types[uploadDocInfo[key].value].id,
				);
			} else if (key === 'IssueDate') {
				formData.append(
					'IssueDate',
					getFormattedDate(new Date(uploadDocInfo[key].value))
				);
			} else if (key === 'ReferenceNumber') {
				formData.append('RefNumber', uploadDocInfo[key].value)
			} else if (key === 'bank_types') {
				formData.append('bank_id', uploadDocInfo[key].value);
			} else if (key === 'document_password') {
				formData.append('password', uploadDocInfo[key].value);
			} else {
				formData.append(key, uploadDocInfo[key].value);
			}
		});
		if (co_applicants)
			formData.append('cl_coapplicant_id', co_applicants)
		uploadedFiles.forEach((ele) => {
			formData.append('file[]', ele)
		});
		try {
			const response = await MasterDataService.uploadDocument(
				state.userType,
				'co-lender',
				leadId,
				formData,
				selectedLender
			);
			if (response?.data?.status?.code === 1) {
				let success = response?.messages?.success;
				toast.success(
					success?.form?.[0] || success?.others?.[0] || message.UPLOAD_SUCCESS
				);
				inputRef.current.value = '';
				setUploadedFiles([]);
				setUploadDocInfo(defaultState);
				getLeadDocument(false);
				getLeadDetail();
				setModalState(!modalState);
			} else {
				let error = response.messages.error;
				toast.error(
					error?.others?.[0] || error?.fields?.file?.[0] || error?.form?.[0] || message.ERROR_FORM
				);
			}
		} catch (err) {
			let error = err?.response?.data.messages?.error;
			let error_msg = err?.response?.data.messages?.error?.fields
			let error_msg_dump = []
			for (let key in error_msg) {
				error_msg_dump.push(error_msg[key])
			}
			let show_err_nag = error_msg_dump.join(' ! ')
			setErrors(error);
			toast.error(show_err_nag || error?.others?.[0] || error?.form?.[0] || message.ERROR_FORM);
		}
		setLoading(false);
	};
	const documentFieldChangeHandler = (value, key) => {
		setErrors({});
		if (key === 'document_types') {
			let currentDocument = documentData.document_types[value];
			setDocID(()=>currentDocument?.doc_id);
			if (
				currentDocument?.document_is_doc_info === 1 &&
				currentDocument?.lender_is_doc_info === 1
			) {
				return setUploadDocInfo({
					[key]: {
						...uploadDocInfo[key],
						value: value,
					},
					...additionalFields,
					...(currentDocument?.protected_file === 1 && { ...bankFields }),
					...(currentDocument?.is_bank_info === 1 && {
						...bankStatementFields,
					}),
					...(currentDocument?.is_report_info === 1 && {
						...reportFields,
					}),
					...(currentDocument?.is_ref_number == 1 && {
						...docInfo,
					}),
					...(currentDocument?.is_anual_turnover == 1 && {
						...annualTurnOver,
					}),
					...(currentDocument?.is_industry_type == 1 && {
						...industryType,
					}),
					...(currentDocument?.is_sub_industry_type == 1 && {
						...subIndustryType,
					}),
					...(currentDocument?.is_business_sector == 1 && {
						...businessSector,
					}),
					...(currentDocument?.is_business_sub_sector == 1 && {
						...businessSubSector,
					}),
				});

			} else {
				return setUploadDocInfo({
					[key]: {
						...uploadDocInfo[key],
						value: value,
					},
					...(currentDocument?.is_bank_info === 1 && {
						...bankStatementFields,
					}),
					...(currentDocument?.protected_file === 1 && { ...bankFields }),
					...(currentDocument?.is_report_info === 1 && {
						...reportFields,
					}),
					...(currentDocument?.is_ref_number == 1 && {
						...docInfo,
					}),
					...(currentDocument?.is_anual_turnover == 1 && {
						...annualTurnOver,
					}),
					...(currentDocument?.is_industry_type == 1 && {
						...industryType,
					}),
					...(currentDocument?.is_sub_industry_type == 1 && {
						...subIndustryType,
					}),
					...(currentDocument?.is_business_sector == 1 && {
						...businessSector,
					}),
					...(currentDocument?.is_business_sub_sector == 1 && {
						...businessSubSector,
					}),
				});
			}
		}
		if (key === "account_type") {
			if (value === "OverDraft") {
				let temp = {
					...uploadDocInfo,
					[key]: {
						...uploadDocInfo[key],
						value: value,
					}
				}
				setUploadDocInfo({ ...temp, odcc_limit: { type: "text", value: null, label: "ODCC Limit" } })
			} else {
				let temp = {
					...uploadDocInfo,
					[key]: {
						...uploadDocInfo[key],
						value: value,
					}
				};
				delete temp.odcc_limit;
				setUploadDocInfo(temp)
			}
		} else {
			setUploadDocInfo({
				...uploadDocInfo,
				[key]: {
					...uploadDocInfo[key],
					value: value,
				},
			});
		}
	};

	const checkUploadButtonDisabled = () => {
		var allDocSelect = true;
		if (uploadDocInfo?.document_types?.value === 'Select' || uploadDocInfo?.document_types?.value == '') {
			allDocSelect = false;
		}
		let flag = true;
		for (var key in uploadDocInfo) {
			if (!uploadDocInfo[key].value && !['odcc_limit', 'ReferenceNumber', 'document_password', 'score'].includes(key)) {
				allDocSelect = false;
			}
		}
		if (!allDocSelect || uploadedFiles?.length === 0 || loading) {
			flag = false
		} else {
			flag = true
		}
		return !flag;
	};
	const fetchDmsDocuments = async () => {
		setFetchingDocuments(true);
		try {
			const response = await LenderUgroService.fetchDocuments(leadId);
			if (response?.data?.status?.code === 1) {
				getLeadDocument(false);
				toast.success(
					response?.data?.messages?.success?.others[0] ||
					'DMS documents fetched successfully'
				);
			} else {
				toast.error(
					response?.message ||
					response?.messages?.error?.form?.[0] ||
					response?.messages?.error?.others?.[0] ||
					message.ERROR
				);
			}
		} catch (err) {
			toast.error(
				err.response?.data?.message ||
				err.response?.data?.messages?.error?.form[0] ||
				err.response?.data?.messages?.error?.others[0] ||
				message.ERROR
			);
		}
		setFetchingDocuments(false);
	};

	React.useLayoutEffect(() => {
		getLeadDocument(true);
	}, [selectedLender, allSelected]);
	const setDefaultState = () => {
		setUploadDocInfo(defaultState);
	};
	React.useLayoutEffect(() => {
		if (state.userType === 'admin') {
			setDefaultState();
		}
	}, [selectedLender, modalState]);

	const formatRows = (documents) => {
		return documents.document_file.map((document) => ({
			...document,
			checked: viewableSelectedLender(document),
		}));
	};
	const checkHasPermission = (checkPermission) => {

		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	let docApiCall = async (row) => {
		try {
			const response = await LenderUgroService.toggleDocumentForLender(
				state.userType,
				state.userType === 'admin' ? 'co-lender' : null,
				{
					doc_lender_updates: [{ [row.lead_doc_file_id]: row.checked ? 1 : 0 }],
					lender_id: selectedLender,
				}
			);
			setIsDocumentSubmmiting(-1)
			const success = response?.data?.messages?.success;
			toast.dismiss()
			toast.success(
				success?.form?.[0] || success?.others?.[0] || message.UPDATE_SUCCESS
			);
			getLeadDocument(false);

		} catch (err) {
			setIsDocumentSubmmiting(-1)
			let error = err?.response?.data?.messages?.error;
			toast.dismiss()
			toast.error(
				error?.fields?.doc_password?.[0] ||
				error?.fields?.lender_id?.[0] ||
				error?.others?.[0] ||
				message.ERROR_FORM
			);
		}
	}
	const toggleDocumentVisibilityForLender = async (
		tableData,
		selectedRowCount,
		checked,
		index
	) => {
		const row = tableData[index];
		setIsDocumentSubmmiting(index);
		if (tableData[index]?.bank_id && !(tableData[index]?.password || '').trim() && row?.checked) {
			setConfirmModal(!confirmModal)
			setRowdata(row)
		} else {
			toast.info("Document is submitting. Please wait...")
			docApiCall(row)
		}
	};

	const getBankNameList = async () => {
		const response = await MasterDataService.getDocumentList(
			state.userType,
			'co-lender',
			leadId,
			selectedLender
		);
		let applicant_data_type = response?.data?.data?.co_applicants
		let applicant_data = []
		for (const [key, value] of Object.entries(applicant_data_type)) {
			applicant_data.push({ id: key, value })
		}
		setApplicantData(applicant_data)
	}
	useEffect(() => {
		getBankNameList()
		setUploadDocInfo(defaultState);
	}, [])
	const handleUploadFiles = files => {
		const uploaded = [...uploadedFiles];
		let limitExceeded = false;
		files.some((file) => {
			if (uploaded.findIndex((f) => f.name === file.name) === -1) {
				uploaded.push(file);
				if (uploaded.length > MAX_COUNT) {
					toast.error(`please select less than  ${Number(MAX_COUNT) + 1} File`)
					limitExceeded = true;
					return true;
				}
			}
		})
		if (!limitExceeded) setUploadedFiles(uploaded)
	}
	const handleFileEvent = (e) => {
		if (e.target.files.length > 0) {
			const chosenFiles = Array.prototype.slice.call(e.target.files)
			handleUploadFiles(chosenFiles);
		} else {
			setUploadedFiles([])
		}
	}
	const HandleDelete = (ele) => {
		let files = uploadedFiles.filter((file, ind) => {
			return file.name != ele.name
		});
		setUploadedFiles(files)
		if (files.length == 0) {
			inputRef.current.value = '';
		}
	}
	const handleCheckPassword = (type) => {
		if (type == 'yes') {
			toggleModalConfirm()
			setIsDocumentSubmmiting(-1);
		}
		if (type == 'no') {
			toast.info("Document is submitting. Please wait...")
			docApiCall(rowdata)
			toggleModalConfirm()
		}
	}

	const getSelectedDocument = (docName) => {
		// console.log(docName);
		objectsForEach(documentList)?.map(({ id, value }) => {
			if (id == docName) {
				setActiveDoc(docName)
				setDocCount(value[0]?.document_file?.length)
				setSelectedDocValue(value)
				// return console.log(" ==== ", value);
			}
		})
	}

	const isDocSubmittedToLender = (value, lender_id) => {
		let doc_files = value?.[0]?.['document_file'];
		return (doc_files || []).some(({for_lenders})=> for_lenders.includes(lender_id));
	}

	const getOptions = (doc_type, opt) => {
		let ind = uploadDocInfo?.['industry_type']?.value;
		if(doc_type == 'sub_industry_type'){
			let sub_ind_org = [];
			let sub_ind = {};
			for(const { id, name, sub_industry } of opt){
				if(name == ind){
					sub_ind_org = sub_industry;
					break;
				}
			}
			for(const { id, name } of sub_ind_org){
				sub_ind[name]= name;
			}
			return sub_ind
		}
		return opt;
	}

	return (
		<>
			<div className='d-flex justify-content-between align-items-center' style={{ marginTop: "-8px" }}>
				{/* <div className='d-flex justify-content-between align-items-center detailspagedata'> */}
				{/* {!location.pathname.includes('post-disbursal') && cl_lead_lender_status && <div className=''>
					{state.userType === 'admin' && (
						// <div className='custom_radio_control mr-4 mt-1'>
						<div className='custom_radio_control mr-4'>
							<input
								type='checkbox'
								onChange={(e) => setAllSelected(e.target.checked)}
								checked={allSelected}
							/>
							<label className='ml-1' style={{ color: '#707070' }}>Show all Documents</label>
						</div>
					)}
				</div>} */}
				<div>
				</div>
				 
					<div className='d-flex justify-content-end'>
						{checkHasPermission('fetch-documents') && 
						!location.pathname.includes('post-disbursal') && 
						<button
							className='btn btn-custom btn-custom-height newButton'
							onClick={fetchDmsDocuments}
							disabled={fetchingDocuments ? true : false}
						>
							{fetchingDocuments ? (
								<div className='loader' />
							) : (
								<span className=''><i class="fa fa-refresh mr-1" aria-hidden="true"></i>Fetch Documents</span>
							)}
						</button>}
					{checkHasPermission('upload-documents') && 
						<button
							className='btn btn-custom btn-custom-height ml-1 newButton'
							onClick={toggleModal}
						>
							<span className="mr-1"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload more Documents</span>
						</button>}
				</div>

			</div>
			{docloader && docloderHandler ? <div className='Tableloader' style={{ margin: "10% auto auto auto" }}></div>
				:
				(selectedDocValue || []).length === 0 ?
					<div className="d-flex justify-content-center" style={{ marginTop: '100px', fontSize: '16px' }}>{isPostDisbursalCase ? 'No SOA Documents Found' : 'No Documents Found'}</div>
					:
					<>
						<div className="row view-container mt-2">
							<div className="col-md-3">
								<div className="documentLeftPart">
									{docKeys?.map(({ docName, docCount, value }) => {
										return (
											<p
												className={`d-flex justify-content-between ${activeDoc === docName && 'activeDocument'}`}
												onClick={() => getSelectedDocument(docName)}
											>
												<div style={{ cursor: 'pointer' }}>
													{`(${docCount}) ${docName}`}
													{leadInfo?.req_docs?.includes(docName) && <span className='text-danger ml-1'>*</span>}
													{isDocSubmittedToLender(value, selectedLender) && <i className="fa fa-check" style={{'color': '#04AA6D', 'margin-left': '5px'}} aria-hidden="true"></i>}
												</div>
												{activeDoc === docName && <span><i class="fa fa-angle-right fa-lg" aria-hidden="true"></i></span>}
											</p>
										)
									})
									}
								</div>
							</div>
							<div className="col-md-9">
								<div className="documentRightPart">
									<span className='docLegend'>{`${docCount} docs uploaded`}</span>
									<p className='docHeader'>{activeDoc}{leadInfo?.req_docs?.includes(activeDoc) && <span className='text-danger ml-1'>(required)</span>}</p>
									{
										(selectedDocValue || [])?.map((document) => {
											if (isPostDisbursalCase) {
												if (activeDoc === "Statement of Account") {
													return (
														<div className='docTableData'>
															{document?.document_file &&
																document.document_file?.length > 0 ? (
																<div className='post-disbursal-document_table'>
																	<Table
																		rowCheckboxUpdateCallback={
																			toggleDocumentVisibilityForLender
																		}
																		columns={documentFileTableHeaders}
																		rows={formatRows(document)}
																		reloadTable={() => getLeadDocument(false)}
																		showHeaderCheckbox={false}
																		coapplicants={leadInfo?.coapplicants}
																		scoreInput={leadInfo?.cl_lead?.lead_type == 2 && leadInfo?.cl_lead?.loan_amount <= 2500000 && prod_ids.includes(leadInfo?.cl_lead?.prod_type)}
																		// checkbox={true}
																		type='documents'
																		selectedLender={selectedLender}
																		selectedLenderName={selectedLenderName}
																		documentName={activeDoc}
																		documentValue={document}
																		isDocumentSubmitting={isDocumentSubmitting}
																	></Table>
																</div>)
																:
																"No Documents found"
															}
														</div>
													)
												}
											} else {
												return (
													<div className='docTableData'>
														{document?.document_file &&
															document.document_file?.length > 0 ? (
															<div className='document_table'>
																<Table
																	rowCheckboxUpdateCallback={
																		toggleDocumentVisibilityForLender
																	}
																	columns={documentFileTableHeaders}
																	rows={formatRows(document)}
																	reloadTable={() => getLeadDocument(false)}
																	showHeaderCheckbox={false}
																	coapplicants={leadInfo?.coapplicants}
																	scoreInput={leadInfo?.cl_lead?.lead_type == 2 && leadInfo?.cl_lead?.loan_amount <= 2500000 && prod_ids.includes(leadInfo?.cl_lead?.prod_type)}
																	checkbox={true}
																	type='documents'
																	selectedLender={selectedLender}
																	selectedLenderName={selectedLenderName}
																	documentName={activeDoc}
																	documentValue={document}
																	isDocumentSubmitting={isDocumentSubmitting}
																></Table>
															</div>)
															:
															"No Documents found"
														}
													</div>
												)
											}
										})

									}
								</div>
							</div>
						</div>
					</>

			}
			{/* <div className='row mt-5'> */}
			{/* {docloader && docloderHandler ? <div className='Tableloader' style={{ margin: "10% auto auto auto" }}></div> : <div className='row mt-2'>
				<div className='col-md-12'>
					<div className='card border-0'>
						<div className='card-body p-0'>
							{!getDocumentError ? (
								<div id='accordion' className='custom_accordion'>
									{objectsForEach(documentList).map((document, i) => {
										if (isPostDisbursalCase) {
											if (document?.id === "Statement of Account") {
												return (
													<Accordion
														key={i}
														label={
															document.id ||
															(document.value[0].doc_name ==
																'Technical Report Generated by Ugro'
																? 'FI Report'
																: document.value[0].doc_name)
														}
														required={
															// !document.value[0]?.is_uplod &&
															// cl_lead_lender_status &&
															// cl_lead_lender_status.lender_id === 3 &&
															// document.value[0]?.is_required > 0
															[]
														}
														count={document.value[0]?.document_file?.length}
														headerId={'heading' + i}
														collapseId={'collapse' + i}
														isDocumentAccordion={true}
														isPostDisbursalCase={true}
													>
														{document.value[0]?.document_file &&
															document.value[0].document_file?.length > 0 ? (
															<div className='post-disbursal-document_table'>
																<Table
																	columns={documentFileTableHeaders}
																	rows={formatRows(document)}
																	reloadTable={getLeadDocument}
																	type='documents'
																	selectedLender={selectedLender}
																	selectedLenderName={selectedLenderName}
																	documentList={document}
																></Table>
															</div>
														) : (
															<span className="d-flex justify-content-center m-2"><h6>No Documents Available</h6></span>
														)}
													</Accordion>
												);
											}
										} else {
											if (document.value[0]?.document_file?.length > 0 || (leadInfo?.req_docs || [])?.includes(document.id ||
												(document.value[0].doc_name ==
													'Technical Report Generated by Ugro'
													? 'FI Report'
													: document.value[0].doc_name))) {
												return (
													<Accordion
														key={i}
														label={
															document.id ||
															(document.value[0].doc_name ==
																'Technical Report Generated by Ugro'
																? 'FI Report'
																: document.value[0].doc_name)
														}
														required={
															// !document.value[0]?.is_uplod &&
															// cl_lead_lender_status &&
															// cl_lead_lender_status.lender_id === 3 &&
															// document.value[0]?.is_required > 0
															leadInfo?.req_docs
														}
														count={document.value[0]?.document_file?.length}
														headerId={'heading' + i}
														collapseId={'collapse' + i}
														isDocumentAccordion={true}
														documentFiles={document.value[0]?.document_file}
														reloadDocuments={getLeadDocument}
														cl_lead_lender_status={leadInfo?.cl_lead_lender_status < 4 ? true : false}
														cl_lead_doc_id={document.value[0]?.cl_lead_doc_id}
														selectedLender={selectedLender}
														is_all_docs_checked={JSON.parse(document.value[0]?.is_all_docs_checked)?.[selectedLender]}
														hasExtraFields={(document.value[0]?.document?.is_bank_info === 0 && document.value[0]?.document?.is_report_info === 0 && document.value[0]?.document?.protected_file === 0)}
													>
														{document.value[0]?.document_file &&
															document.value[0].document_file?.length > 0 ? (
															<div className='document_table'>
																<Table
																	rowCheckboxUpdateCallback={
																		toggleDocumentVisibilityForLender
																	}
																	columns={documentFileTableHeaders}
																	rows={formatRows(document)}
																	reloadTable={getLeadDocument}
																	showHeaderCheckbox={false}
																	checkbox={true}
																	type='documents'
																	selectedLender={selectedLender}
																	selectedLenderName={selectedLenderName}
																	documentList={document}
																	isDocumentSubmitting={isDocumentSubmitting}
																></Table>
															</div>
														) : (
															<span className="d-flex justify-content-center m-2"><h6>No Documents Available</h6></span>
														)}
													</Accordion>
												);
											}
										}
									})}
								</div>
							) : (
								<p>{getDocumentErrorMessage}</p>
							)}
						</div>
					</div>
				</div>
			</div>} */}

			<Modal state={modalState} style={{ width: '450px' }} removeBorderSpace={true} shouldCloseOnOverlayClick={false}>
				<div className='card border-0'>
					<div className="modal-header-container">
						<div className="modal-title">Upload More Documents</div>
						<div className="closeModalView" onClick={toggleModal}>
							<span className="closeModalIcon">x</span>
						</div>
					</div>

					<div className='p-4 modalData' style={{ overflowY: "auto", overflowX: "clip", maxHeight: "92vh" }}>
						<form onSubmit={submitUploadDocument}>
							<div class='form-group'>
								<label>Applicant</label>
								<div class='row'>
									<div class='col-12'>
										<select className='form-control' value={co_applicants} onChange={(e) => { setco_applicants(e.target.value); getReportFields(e.target.value, null); }}>
											<option value=''>Applicant</option>
											{applicantData && applicantData.map(({ id, value }) => {
												return (
													<option value={id}>{value + (' (Co-applicant)')}</option>
												)
											})}
										</select>
									</div>
								</div>
							</div>
							<div>
								{objectsForEach(uploadDocInfo).map(({ id, label }) => (
									<DocumentUploadField
										key={id}
										id={id}
										label={label}
										inputType={uploadDocInfo[id].type}
										required={documentData?.doc_info_required}
										onChange={documentFieldChangeHandler}
										dataType={uploadDocInfo?.[id]?.dataType}
										value={uploadDocInfo[id].value}
										options={getOptions(id, documentData?.[id])}
										error={errors?.fields?.[id]}
										isSOA={location.pathname.includes('post-disbursal') ? true : false}
									/>
								))}
							</div>

							<div className='form-group'>

								<label>Upload Document</label>
								<div className='border border-ronded ' style={{ height: "35px" }}>
									<input id="img" style={{ display: "none", }}
										ref={inputRef}
										file={uploadedFiles}
										onChange={handleFileEvent}
										type='file'
										multiple
										className='form-control ' />
									<label for="img" style={{ padding: " 5px", marginTop: "4px", border: '1px solid grey', fontWeight: "600", cursor: "pointer" }}>Choose a File</label>
									{uploadedFiles.length > 0 && <label for="img" style={{ padding: "5px ", fontSize: "12px", fontWeight: "600" }}>{uploadedFiles.length + ' files'}</label>}

								</div>
								{/* <div className='row d-flex align align-items-center justify-content-center'>
									<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
										<div className='form-group docUpload'>
											<input
												ref={inputRef}
												file={uploadedFiles}
												// onChange={(e) => handleChange(e)}
												onChange={handleFileEvent}
												type='file'
												multiple
												className='form-control '
											/>
										</div>
									</div>
								</div> */}
							</div>
							{uploadedFiles.map((ele, index) => {
								return (
									<div className='mx-3 my-1 py-1'>
										<div className='row border border-rounded' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
											<div className='col-11'>
												<span>{ele.name}</span>
											</div>
											<div className='col-1' style={{ cursor: "pointer" }}>
												<i class="fa fa-times-circle-o fa-lg text-orange float-right " aria-hidden="true" onClick={() => HandleDelete(ele)}></i>
											</div>
										</div>
									</div>
								)
							})}
							<div className='col-lg-12 col-md-12 col-sm-12 col-12 text-center m-auto'>
								{(state.userType === 'admin'
									? checkHasPermission('upload-documents')
									: true) && (
										<button
											className='btn btn-custom btn-custom-height p-0 m-auto'
											disabled={checkUploadButtonDisabled()}
										>
											{loading ? (
												<div className='loader'></div>
											) : (
												'Upload'
											)}
										</button>
									)}
							</div>
						</form>
					</div>
				</div>
			</Modal>
			<Modal state={confirmModal} closeModal={toggleModalConfirm} style={{ width: '450px' }} removeBorderSpace={true}>
				<div className='card border-0'>
					<div className="modal-header-container">
						<div className="modal-title">Document Info</div>
						<div className="closeModalView" onClick={toggleModalConfirm}>
							<span className="closeModalIcon">x</span>
						</div>
					</div>
					<div className='text-center mt-3'>
						Is this document password protected ?<br />
						If <b>Yes</b>, please click on <b>Edit Button </b>
						{/* <i className='fa fa-pencil' style={{background:"#ea652b" , padding:" 4px 10px",color:"white",borderRadius:"3px"}}></i>  */}
						to update password.
					</div>
					<div className='d-flex justify-content-center align-items-center mt-2 mb-3'>
						<button
							type='button'
							className='btn btn-custom'
							onClick={() => handleCheckPassword('yes')}
						>
							YES
						</button>
						<button
							type='button'
							className='btn btn-outline-custom ml-2'
							onClick={() => handleCheckPassword('no')}
						>
							NO
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Documents;

